import { LogOut } from 'lucide-react';
import { useWallet } from '../hooks/WalletContext';

export const WalletConnectButton = () => {
  const { connect, disconnect, isConnected } = useWallet();

  const baseStyles = `
    inline-flex items-center justify-center gap-2
    rounded-lg font-medium text-white
    transition-all duration-200 ease-in-out
    shadow-sm hover:shadow-md hover:brightness-105
    focus:outline-none focus:ring-2 focus:ring-offset-2
    w-full sm:w-auto
  `;

  const commonPadding = `px-3 py-1.5 sm:px-4 sm:py-2`;
  const textSizing = `text-xs sm:text-sm`;

  return isConnected ? (
    <button
      onClick={disconnect}
      className={`
        bg-gradient-to-r from-red-500 to-pink-500
        ${baseStyles} ${commonPadding} ${textSizing}
      `}
    >
      <LogOut size={16} />
      <span className="hidden sm:inline">Disconnect Wallet</span>
      <span className="sm:hidden">Disconnect</span>
    </button>
  ) : (
    <button
      onClick={connect}
      className={`
        bg-gradient-to-r from-blue-500 to-sky-600
        ${baseStyles} ${commonPadding} ${textSizing}
      `}
    >
      <span className="hidden sm:inline">Connect Metamask Wallet</span>
      <span className="sm:hidden">Connect</span>
    </button>
  );
};
